if (!customElements.get('qlf-category-menu-controller')) {
  class QlfCategoryMenuController extends HTMLElement {}
  customElements.define('qlf-category-menu-controller', QlfCategoryMenuController);
}

(() => {
  const menu = document.getElementById('qlf-category-menu');
  if (!menu || menu.dataset.initialized) return;
  menu.dataset.initialized = 'true';

  const dialog = menu.querySelector('[role="dialog"]');
  const triggers = document.querySelectorAll('.qlf-category-menu-trigger');
  const desktopTriggers = document.querySelectorAll('.qlf-category-menu-trigger.menu-link');
  const focusableSelector = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
  const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const CLOSE_DURATION = 280; // must outlast the longest closing transition in the CSS
  const HOVER_OPEN_DELAY = 60;
  const HOVER_CLOSE_DELAY = 200;
  let returnFocus = null;
  let openTimer = null;
  let closeTimer = null;
  let hideTimer = null;

  const clearTimers = () => {
    window.clearTimeout(openTimer);
    window.clearTimeout(closeTimer);
    window.clearTimeout(hideTimer);
  };

  const setExpanded = (state) => triggers.forEach((item) => item.setAttribute('aria-expanded', state));

  // Anchor the panel right under the header. Measured live off the real element, because
  // --header-height is only the header's own height and ignores the announcement bar above it.
  const header = menu.closest('theme-header') || document.querySelector('theme-header, #header, header');

  // Drives both the panel offset and where the backdrop starts, so the header stays untouched.
  const anchorToHeader = () => {
    if (!header) return;
    const bottom = Math.max(header.getBoundingClientRect().bottom, 0);
    menu.style.setProperty('--qlf-header-bottom', `${Math.round(bottom)}px`);
  };

  const open = (trigger, asModal = true) => {
    clearTimers();
    if (trigger) returnFocus = trigger;
    menu.classList.remove('is-closing');
    if (menu.hidden) {
      anchorToHeader();
      menu.hidden = false;
      void menu.offsetWidth; // commit the closed state so the transition actually runs
    }
    menu.classList.add('is-open');
    setExpanded('true');
    if (asModal) {
      document.body.classList.add('overflow-hidden');
      dialog.focus();
    }
  };

  const close = (restoreFocus = true) => {
    clearTimers();
    if (menu.hidden) return;
    // is-closing freezes the content where it is, so only the panel animates out
    if (menu.classList.contains('is-open')) menu.classList.add('is-closing');
    menu.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    setExpanded('false');
    hideTimer = window.setTimeout(() => {
      menu.hidden = true;
      menu.classList.remove('is-closing');
    }, CLOSE_DURATION);
    if (restoreFocus) returnFocus?.focus();
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => menu.classList.contains('is-open') ? close() : open(trigger));
  });
  const scheduleOpen = (trigger) => {
    if (!supportsHover.matches) return;
    clearTimers();
    openTimer = window.setTimeout(() => open(trigger, false), HOVER_OPEN_DELAY);
  };
  const scheduleClose = () => {
    if (!supportsHover.matches) return;
    window.clearTimeout(openTimer);
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(() => close(false), HOVER_CLOSE_DELAY);
  };
  desktopTriggers.forEach((trigger) => {
    trigger.addEventListener('mouseenter', () => scheduleOpen(trigger));
    trigger.addEventListener('mouseleave', scheduleClose);
  });
  dialog.addEventListener('mouseenter', () => {
    if (!supportsHover.matches) return;
    clearTimers();
  });
  dialog.addEventListener('mouseleave', scheduleClose);
  menu.querySelectorAll('[data-category-menu-close]').forEach((button) => button.addEventListener('click', close));
  // Keep the panel anchored to the header while it moves.
  const reanchor = () => { if (!menu.hidden) anchorToHeader(); };
  window.addEventListener('scroll', reanchor, { passive: true });
  window.addEventListener('resize', reanchor, { passive: true });
  document.addEventListener('keydown', (event) => {
    if (menu.hidden) return;
    if (event.key === 'Escape') close();
    if (event.key !== 'Tab') return;
    const focusable = [...menu.querySelectorAll(focusableSelector)];
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
})();
